import { ILeftRightSectionProps } from "./LeftRightSection";

export const View = (props: ILeftRightSectionProps) => {
  return (
    <div
      className={
        (props.hasBorder ? "has-border" + " " : "") + "left-right-section"
      }
    >
      <div className="left-text">{props.leftText}</div>
      <div className="right-text">{props.rightText}</div>
    </div>
  );
};
